import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface NavigationState {
  showOrgNav: boolean;
  headerName: string;
}

export const NavigationSlice = createSlice({
  name: 'navigation',
  initialState: {
    showOrgNav: false,
    headerName: ''
  },
  reducers: {
    setShowOrgNav: (
      state: NavigationState,
      action: PayloadAction<boolean>
    ) => {
      state.showOrgNav = action.payload;
    },
    setHeaderName: (
      state: NavigationState,
      action: PayloadAction<string>
    ) => {
      state.headerName = action.payload;
    },
  }
});

export const selectHeaderName = (state: RootState) => state.navigation.headerName;

export const {
  setShowOrgNav,
  setHeaderName
} = NavigationSlice.actions;

export default NavigationSlice.reducer;
